export default "https://cdn-static.gokick.com/assets/4e3548e0bbc963e39203d4ae4090204efad0894d/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";